import { BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA } from '../types'

export default function bloquearPoltronaJaMarcadoItinerarioIda (assento, fileira) {
  return {
    type: BLOQUEAR_POLTRONA_JA_MARCADO_ITINERARIO_IDA,
    payload: { assento, fileira }
  }
}
